<template>
  <v-menu
    bottom
    right
    offset-y
    :close-on-content-click="false">
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        icon
        v-bind="attrs"
        v-on="on"
        color="#f7f7f7">
        <v-icon>mdi-apps</v-icon>
      </v-btn>
    </template>
    <v-card max-width="300" tile>
      <v-list nav dense>
        <v-subheader>
          Portals
          <v-icon small class="ml-2">mdi-launch</v-icon>
        </v-subheader>
        <div class="portal-links-container">
          <v-list-item
            v-for="portal in availablePortals"
            :key="portal.key"
            class="portal-link"
            link
            @click="navigate(portal)"
            style="min-height: auto">
            <div class="portal-link-content">
              <v-btn
                plain
                icon
                class="mx-auto">
                <v-icon>{{ portal.icon }}</v-icon>
              </v-btn>
              <v-list-item-action-text class="pa-0 ma-0">
                {{ portal.name }}
              </v-list-item-action-text>
            </div>
          </v-list-item>
        </div>
      </v-list>
    </v-card>
  </v-menu>
</template>
<script>
import { buildUrl } from '../../mixins/build-url';
import { userAccess } from '../../mixins/user-access';
export default {
  name: 'PortalNavMenu',
  props: {
    active: String
  },
  mixins: [buildUrl, userAccess],
  computed: {
    portals () {
      return [
        { name: 'Ad Planner', key: 'adplan', icon: 'mdi-newspaper-variant-outline' },
        { name: 'Billing', key: 'billing', icon: 'mdi-calendar-clock' },
        { name: 'Customer', key: 'customer', icon: 'mdi-storefront' },
        { name: 'Items', key: 'item', icon: 'mdi-barcode-scan' },
        { name: ['jbg', 'alliance-retail-group'].includes(this.$auth.tenant) ? 'Documents' : 'Partner', key: 'partner', icon: 'mdi-folder-account-outline' },
        { name: 'Promotions', key: 'promo', icon: 'mdi-tag-outline' },
        { name: 'TPR Manager', key: 'tpr', icon: 'mdi-account-tie-woman', tenants: ['awg', 'pricechopper','alliance-retail-group'] }
      ]
    },
    availablePortals () {
      let portals
      if (this.$auth.tenant === 'alliance-retail-group') {
        const portalKeyMap = {
          ad_planner: 'adplan',
          billing: 'billing',
          customer: 'customer',
          partner: 'partner',
          item: 'item',
          promo: 'promo',
          tpr: 'tpr'
        }
        const allowedKeys = this.userAccessiblePortals
          .map(portal => portalKeyMap[portal])
          .filter(portalKey => portalKey !== undefined)
        portals = this.portals.filter(portal => allowedKeys.includes(portal.key))
        return this.sortPortals(portals)
      }

      portals = this.portals.filter(portal => !portal.tenants || portal.tenants.includes(this.$auth.tenant))
      return this.sortPortals(portals)
    }
  },
  methods: {
    navigate (portal) {
      if (portal.key === this.active) return
      const url = this.buildPortalUrl(portal.key)
      window.location.href = url
    },
    sortPortals (portals) {
      return [...portals].sort((first, second) => first.name.localeCompare(second.name))
    },
  }
}
</script>
<style>
.portal-links-container {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-gap: 3px;
}

.portal-link {
  display: grid;
  justify-content: center;
  padding: 4px;
  height: 100%;
}

.portal-link-content {
  display: grid;
  justify-content: center;
  max-height: 53px;
  text-align: center;
}
</style>
